export const exportPaymentsExcelUrl = "/payment/exportPaymentsExcel/{date}";
export const getInvoicesByDayUrl = "/payment/getInvoicesByDay/{day}";
export const cancelPaymentUrl = "/payment/cancelPayment";
